import './AwardsSection.css'
import AwardCard from './AwardCard'

/**
 * Generates a stable unique identifier for an award when ID is missing.
 * Uses award properties to create a deterministic, stable key.
 */
function getAwardKey(award, index) {
  if (award.id) return award.id

  // Generate stable key from deterministic award properties
  const deterministicParts = [
    award.award_definition_id,
    award.user_id,
    award.earned_at,
  ].filter(Boolean)

  // If we have at least one deterministic part, build the key from that.
  if (deterministicParts.length > 0) {
    return `award-${deterministicParts.join('-')}`
  }

  // As a last resort when no other information is available, fall back to index.
  return `award-${index}`
}

export default function AwardsSection({ title, awards, emptyMessage }) {
  if (!awards || awards.length === 0) {
    return (
      <div className="awards-section">
        <h2 className="awards-section-title">{title}</h2>
        <div className="awards-section-empty">{emptyMessage}</div>
      </div>
    )
  }

  return (
    <div className="awards-section">
      <h2 className="awards-section-title">
        {title}{' '}
        <span className="awards-count" aria-label={`${awards.length} awards`}>
          ({awards.length})
        </span>
      </h2>
      <div className="awards-grid">
        {awards.map((award, index) => (
          <AwardCard key={getAwardKey(award, index)} award={award} />
        ))}
      </div>
    </div>
  )
}
